var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22941 9.07102C6.22277 9.07102 6.21598 9.07087 6.20919 9.07073C6.01058 9.06509 5.82323 8.97799 5.69092 8.83008L3.81069 6.72625C3.54491 6.42884 3.57048 5.97225 3.86789 5.70647C4.1653 5.44041 4.62189 5.46626 4.88767 5.76367L6.25873 7.29782L10.7866 2.77006C11.0684 2.4881 11.526 2.4881 11.8079 2.77006C12.09 3.05216 12.09 3.50947 11.8079 3.79143L6.74002 8.85941C6.60439 8.99518 6.42066 9.07102 6.22941 9.07102Z",
    fill: "#16A665"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C2.9159 13 0 10.0841 0 6.5C0 2.9159 2.9159 0 6.5 0C7.68892 0 8.85242 0.324133 9.8644 0.937589C10.2056 1.14429 10.3145 1.58831 10.1079 1.92949C9.90109 2.27067 9.45707 2.37972 9.11589 2.17288C8.32953 1.69636 7.42488 1.44444 6.5 1.44444C3.71237 1.44444 1.44444 3.71237 1.44444 6.5C1.44444 9.28763 3.71237 11.5556 6.5 11.5556C9.28763 11.5556 11.5556 9.28763 11.5556 6.5C11.5556 6.28521 11.5418 6.06854 11.5151 5.85607C11.4648 5.46029 11.7451 5.09889 12.1408 5.04877C12.5366 4.99836 12.8979 5.27887 12.948 5.6745C12.9825 5.94707 13 6.22469 13 6.5C13 10.0841 10.0841 13 6.5 13Z",
    fill: "#16A665"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.0095905391efdf96a5a8fee52eb09799.svg";
export { ForwardRef as ReactComponent };